import { FormEventHandler, ReactNode } from "react";
import "./AuthCard.css";

type AuthCardProps = {
  error?: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  submitAction: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
};

export default function AuthCard({
  error,
  onSubmit,
  submitAction,
  footer,
  children,
}: AuthCardProps) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        {error && <p className="form-error">{error}</p>}
        <form className="form-grid" onSubmit={onSubmit}>
          {children}
          {submitAction}
        </form>
        {footer}
      </div>
    </div>
  );
}
